import React, { forwardRef } from "react";
import { GiConvergenceTarget } from "react-icons/gi";
import { CenterFocusStrong, Edit, FitScreenRounded, Save } from "@mui/icons-material";
import { Button, Tooltip } from "@mui/material";

const SaveButton = ({open}) => {
  const hoverBtnDescription = (
    <p style={{ fontSize: "1rem", margin: 0 }}>Save Chart</p>
  );
  return (
    <Tooltip
      title={hoverBtnDescription}
      disableinteractive="true"
      slotprops={{
        tooltip: {
          sx: {
            bgcolor: "#545859",
          },
        },
      }}
    >
      <span>
        <Button
          variant="contained"
          className="context-menu-btns"
          sx={{
            backgroundColor: "#ffffff",
            border: "1px solid #00449e",
            borderColor: "#00449e",
            cursor: "pointer",
            borderRadius: "0.5rem",
            color: "#00449e",
                "&:hover": {
                  backgroundColor: "#eaf1fb",
                },
                "&:focus:not(:hover)": {
                  backgroundColor: "#ffffff",
                  boxShadow: "none",
                },
          }}
          onClick={open}
          //   ref={ref}
        >
          <Save size="1rem" sx={{ color: "#00449e" }} />
        </Button>
      </span>
    </Tooltip>
  );
};

export default SaveButton;
